import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import useSiteMetadata from '../hooks/useSiteMetadata'
import useFaqItems from '../hooks/useFaqItems'
import useSEOMetadata from '../hooks/useSEOMetadata'
import { generateGoogleRichResults } from './FAQ/google-rich-results'

const SEO = ({ children, description, image, title, langKey, iconUrl }) => {
  const { defaultImage, siteUrl, titleTemplate } = useSiteMetadata()

  const SEOMetadata = useSEOMetadata()[langKey]
  const {
    frontmatter: {
      description: defaultDescription,
      title: defaultTitle,
      titleTemplate: defaultTemplateTitle,
      twitterUsername
    }
  } = SEOMetadata.edges[0].node

  const seo = {
    description: description || defaultDescription,
    image: image || defaultImage,
    title: title || defaultTitle,
    titleTemplate: defaultTemplateTitle || titleTemplate
  }

  const FAQItems = useFaqItems()
  const FAQData = FAQItems[langKey]
  const googleRichResults = generateGoogleRichResults(FAQData.edges)
  const lang = langKey.replace('_', '-').toLowerCase()

  return (
    <>
      {
        <Helmet
          defaultTitle={seo.title}
          title={seo.title}
          titleTemplate={seo.titleTemplate}
        >
          <html lang={lang} />
          <title lang={lang} itemProp="name">
            {seo.title}
          </title>
          <link rel="shortcut icon" id="favicon" href={iconUrl} />
          <script type="application/ld+json">
            {JSON.stringify(googleRichResults)}
          </script>
          <meta name="description" content={seo.description} />
          <meta name="twitter:creator" content={twitterUsername} />
          <meta name="twitter:description" content={seo.description} />
          <meta name="twitter:image" content={seo.image} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:image" content={siteUrl} />
          <meta property="og:locale" content={langKey} />
          <meta property="og:title" content={seo.title} />
          <meta property="og:url" content={siteUrl} />
          {children}
        </Helmet>
      }
    </>
  )
}

export default SEO

SEO.defaultProps = {
  article: false,
  description: null,
  image: null,
  pathname: null,
  title: null
}

SEO.propTypes = {
  article: PropTypes.bool,
  children: PropTypes.node,
  description: PropTypes.string,
  image: PropTypes.string,
  pathname: PropTypes.string,
  title: PropTypes.string,
  langKey: PropTypes.string
}
